import { FormGroup, FormText } from "reactstrap";
import { RadioButton, Switch, TextInput } from "../../core/form/fields";
import { Card, EditableTable, NurtureAI, NurtureAIRubricsGenerator } from "../../core/components";
import React from "react";
import SubmissionType from "./SubmissionType";
import { useSchoolConfig } from "../../core/hooks";
var AssignmentGradingForm = function AssignmentGradingForm(_ref) {
  var formConfig = _ref.formConfig,
    assignment = _ref.assignment;
  var _useSchoolConfig = useSchoolConfig(),
    nurtureAIEnabled = _useSchoolConfig.nurtureAIEnabled,
    rubricsEnabled = _useSchoolConfig.rubricsEnabled;
  var gradingHeaderText = '2. Implementation';
  var assignmentGrades = [{
    label: 'Marks',
    value: 'marks'
  }, {
    label: 'Percentage',
    value: 'percentage'
  }];
  if (rubricsEnabled) assignmentGrades.push({
    label: 'Rubrics',
    value: 'rubrics'
  });
  var errors = formConfig.formState.errors,
    register = formConfig.register,
    watch = formConfig.watch,
    getValues = formConfig.getValues,
    setValue = formConfig.setValue;
  var watchGraded = watch('graded');
  var watchGradeDisplayToStudent = watch('grade_display_to_students');
  var watchLearningObjectives = watch('assignment_objectives');
  var watchRubrics = watch('rubrics');
  var _ref2 = assignment || {},
    submission_type = _ref2.submission_type;
  var handleRubricsChange = function handleRubricsChange(rubrics) {
    setValue('rubrics', rubrics);
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-5 px-1 px-md-3 p-3",
    headerText: gradingHeaderText,
    headerClass: "big-text text-nurture-purple",
    withHeader: true
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-size-17 font-weight-600 mb-3"
  }, "Grading"), /*#__PURE__*/React.createElement(FormGroup, {
    className: ""
  }, /*#__PURE__*/React.createElement(Switch, Object.assign({
    label: "Grade this assessment"
  }, register('graded')))), watchGraded && /*#__PURE__*/React.createElement(React.Fragment, null, watchGradeDisplayToStudent !== 'rubrics' && /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(TextInput, Object.assign({
    type: "number",
    label: "Maximum Marks",
    placeholder: "Maximum Marks",
    error: !!errors.max_marks
  }, register('max_marks'))), errors.max_marks && /*#__PURE__*/React.createElement("p", {
    className: "mt-1"
  }, /*#__PURE__*/React.createElement(FormText, {
    color: "danger"
  }, errors.max_marks.message))), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap mt-3"
  }, assignmentGrades.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "me-4"
    }, /*#__PURE__*/React.createElement(RadioButton, Object.assign({
      error: !!errors.grade_display_to_students,
      label: item.label,
      value: item.value
    }, register('grade_display_to_students'))));
  })), errors.grade_display_to_students && /*#__PURE__*/React.createElement("p", {
    className: "mt-1"
  }, /*#__PURE__*/React.createElement(FormText, {
    color: "danger"
  }, errors.grade_display_to_students.message))), watchGradeDisplayToStudent === 'rubrics' && rubricsEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, nurtureAIEnabled && /*#__PURE__*/React.createElement(NurtureAI, {
    done: watchRubrics,
    buttonText: "Generate Rubrics",
    className: "mb-4 mt-2",
    subtitle: "Generate a rubric for your assessment with Nurture Assistant"
  }, /*#__PURE__*/React.createElement(NurtureAIRubricsGenerator, {
    assignment: assignment,
    learningObjectives: watchLearningObjectives,
    onSuggest: function onSuggest(rubrics) {
      return handleRubricsChange(rubrics);
    }
  })), /*#__PURE__*/React.createElement(EditableTable, {
    onUpdated: function onUpdated(rubrics) {
      return handleRubricsChange(rubrics);
    },
    learningObjectives: watchLearningObjectives,
    defaultData: watchRubrics || []
  }))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(SubmissionType, {
    register: register,
    submissionType: submission_type
  }));
};
export default AssignmentGradingForm;